import { ArtificialDetailPropertyNames } from '../../../common/globalNotary'
export class BucketConfig {
  constructor (
    fullSelection,
    searchCallback,
    picklistEntityDisplayName,
    searchEntityOptions = null,
    componentType = 'genericSelect', /// enum of genericSelect, hierarchicalSelect, addressSelect, mapSelect
    listItemStyle,
    listItemConfig,
    isAddOnly,
    isReadOnly
  ) {
    // Not sure why James did this. It caused a lot of
    // problems to define properties in this manner. I think
    // he didn't understand pass-by-reference and pass-by-value.
    /*Object.defineProperty(this, 'fullSelection', {
      value: fullSelection,
      writable: true
    })*/
    // ...this was all that was needed. Do a value copy into
    // local class property.
    this.fullSelection = fullSelection.slice()
    this.isAddOnly = isAddOnly
    this.isReadOnly = isReadOnly

    Object.defineProperty(this, 'listItemStyle', {
      value: listItemStyle,
      writable: false
    })
    Object.defineProperty(this, 'listItemConfig', {
      value: listItemConfig,
      writable: false
    })

    Object.defineProperty(this, 'selection', {
      value: searchEntityOptions?.type
        ? this.fullSelection.filter(o => o.type === searchEntityOptions?.type)
        : this.fullSelection,
      writable: false
    })

    Object.defineProperty(this, 'fullProcessingLedger', {
      value: searchEntityOptions?.type
        ? this.fullSelection.filter(o => o.type === searchEntityOptions?.type)
        : this.fullSelection,
      writable: false
    })

    Object.defineProperty(this, 'searchCallback', {
      value: searchCallback,
      writable: false
    })

    Object.defineProperty(this, 'searchNoSystem', {
      value: searchEntityOptions?.noSystem || false,
      writable: false
    })

    Object.defineProperty(this, 'picklistEntityDisplayName', {
      value: picklistEntityDisplayName,
      writable: false
    })
    Object.defineProperty(this, 'searchEntitySubType', {
      value: searchEntityOptions?.type,
      writable: false
    })

    Object.defineProperty(this, 'listPropertyName', {
      value: fullSelection['listPropertyName'],
      writable: false
    })

    Object.defineProperty(this, 'compensationFieldArray', {
      value: fullSelection['compensationFieldArray'],
      writable: false
    })

    Object.defineProperty(this, 'equalityEvaluator', {
      value: fullSelection['equalityEvaluator'],
      writable: false
    })

    Object.defineProperty(this, 'componentType', {
      value: componentType,
      writable: false
    })
    Object.defineProperty(this, 'tempChanges', {
      value: { data: {}, shapeHandleBag: {} },
      writable: true
    })

    Object.defineProperty(this, 'fullList', {
      value: fullSelection['fullList'],
      writable: false
    })

    Object.defineProperty(this, 'categoryList', {
      value: fullSelection['categoryList'],
      writable: false
    })

    this.deepSetSelection = this.deepSetSelection.bind(this)
  }

  setFormikToIdArray (newSelection, formikProperties) {
    // only replacing entries of my own subtype, leave the rest alone
    // Addeding exception for when the search Entity subtype is geo / commercial. for the drop down generation in Territory Groups
    if (this.searchEntitySubType) {
      //record any new faces in the fullProcessingLedger
      //brand new records can come in from the search

      newSelection.forEach(o => {
        if (!this.fullProcessingLedger.some(r => r.id === o.id)) {
          this.fullProcessingLedger.push(o)
        }
      })
      const underLyingIdArray = formikProperties.values[this.listPropertyName]
      if (!underLyingIdArray)
        throw new Error(
          'underlying object does not have the specified property'
        )
      const idArrayOwnedByOtherBuckets = underLyingIdArray.filter(
        oneId => !this.fullProcessingLedger.some(o => o.id === oneId)
      )

      formikProperties.setFieldValue(
        this.listPropertyName,
        newSelection.map(one => one.id).concat(idArrayOwnedByOtherBuckets),
        false
      )
      formikProperties.setFieldTouched(this.listPropertyName)
    } // replace the whole list
    else {
      formikProperties.setFieldValue(
        this.listPropertyName,
        newSelection.map(o => o.id),
        false
      )
      formikProperties.setFieldTouched(this.listPropertyName)
    }
  }

  setFormikToWholeObject (newSelection, formikProperties) {
    if (this.compensationFieldArray && this.equalityEvaluator) {
      const transformedSelection = []
      newSelection.forEach(narrowItem => {
        const newNarrowItem = { ...narrowItem }
        const matchingOldWideItem = this.fullSelection.find(wideItem => {
          return this.equalityEvaluator(wideItem, narrowItem)
        })
        this.compensationFieldArray.forEach(propName => {
          if (matchingOldWideItem) {
            console.log('FOUND WIDE ITEM:', matchingOldWideItem)
            newNarrowItem[propName] = matchingOldWideItem[propName]
          } else {
            newNarrowItem[propName] = ''
          }

          if (this.picklistEntityDisplayName.toLowerCase().includes('owned')) {
            console.log('PARTY SIDE')
            console.log(newNarrowItem)
            if (!newNarrowItem.skillset_id) {
              newNarrowItem.skillset_id = newNarrowItem.id
              newNarrowItem.effective_at = new Date()
              newNarrowItem.expires_at = new Date()
              newNarrowItem.doc_url = ''
            }
          }
          if (
            this.picklistEntityDisplayName
              .toLowerCase()
              .includes('skillset owner')
          ) {
            console.log('SKILLSET SIDE')
            if (!newNarrowItem.party_id) {
              newNarrowItem.party_id = newNarrowItem.id
              newNarrowItem.effective_at = new Date()
              newNarrowItem.expires_at = new Date()
              newNarrowItem.doc_url = ''
            }
          }
        })

        transformedSelection.push(newNarrowItem)
      })

      this.fullSelection.splice(0, this.fullSelection.length)
      transformedSelection.forEach(e => this.fullSelection.push(e))

      // ^^^ POTENTIAL FIX, leaving for now.
      // This is a big fix. Original contents was a reference
      // to the original object, and James was previously deleting
      // this which set the array back zero. This does a value copy.
      // this.fullSelection = transformedSelection.slice()

      formikProperties.setFieldValue(
        this.listPropertyName,
        this.fullSelection,
        true
      )
      //formikProperties.setFieldTouched(this.listPropertyName)
    } else {
      // This is a big fix. Original contents was a reference
      // to the original object, and James was previously deleting
      // this which set the array back zero. This does a value copy.
      this.fullSelection = newSelection.slice()

      formikProperties.setFieldValue(this.listPropertyName, newSelection, true)
    }
  }
  deepSetSelection (newSelection, formikProperties) {
    const isIdArraySelection =
      !Object.values(ArtificialDetailPropertyNames).includes(
        this.listPropertyName
      ) &&
      !this.compensationFieldArray &&
      (
        Boolean(this.searchEntitySubType) ||
        (newSelection.length > 0 && newSelection[0].hasOwnProperty('id'))
      )

    if (isIdArraySelection) {
      // This is a big fix. Original contents was a reference
      // to the original object, and James was previously deleting
      // this which set the array back zero. This does a value copy.
      this.fullSelection = newSelection.slice()

      this.setFormikToIdArray(this.fullSelection, formikProperties)
    } else {
      this.setFormikToWholeObject(newSelection, formikProperties)
    }
  }

  *[Symbol.iterator] () {
    let index = 0
    while (index < this.selection.length) {
      index++
      yield this.selection[index - 1]
    }
  }
}
